// Components
import { defaultButtonTheme } from "../components/Button/theme";
import base from "./base";
import { colors } from "./colors";
import type { CarryTheme } from "./types";

const defaultTheme: CarryTheme = {
  ...base,
  colors: colors,
  button: defaultButtonTheme,
};

export default defaultTheme;
